import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VDialog,{attrs:{"value":_vm.show,"persistent":"","max-width":"800px"}},[_c(VCard,[_c(VCardText,[_c('contact-create',{attrs:{"dialog":true,"client":_vm.client},on:{"close":_vm.close}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }